import {
  afterUploadToServer,
  afterRemoveFromServer,
  removeFromServer,
  getExtension,
} from 'utils/_dropzone.js'
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'

/**
 * @param {HTMLElement} formElement
 */
export default (formElement) => {
  let urlPrefix = window.location.origin + '/uploads/order_attachments/'
  let orderAttachmentsElement = formElement.querySelector('.order-new-form__attachments')
  let previewTemplate = document.getElementById('order-new-form-template').innerHTML
  let orderAttachmentsIdsElement = document.getElementById('order_new_form_attachments')
  let orderAttachmentsDropzone = new Dropzone(orderAttachmentsElement, {
    url: orderAttachmentsIdsElement.dataset.uploadUrl,
    previewsContainer: '#form-dropzone-previews',
    clickable: '#form-dropzone-clickable',
    previewTemplate: previewTemplate,
    maxFilesize: 50,

    init: function() {
      let orderAttachmentsIds = JSON.parse(orderAttachmentsIdsElement.value || '[]') || []
      let files = JSON.parse(orderAttachmentsIdsElement.dataset.mockFiles)
      if (0 !== orderAttachmentsIds.length && files) {
        files.forEach((file) => {
          this.displayExistingFile({serverFileId: file.id, name: file.name, size: file.size}, urlPrefix + file.url)
        })
      }

      this.on("error", function(file, response) {
        file.previewElement.remove()

        loadingWindowVisible('error', '.page__content')

        const errorTextBlock = document.querySelector('.loading__error-text')
        if( errorTextBlock ) {
          const errorMessageBlock = document.getElementById('loading_error_file_upload')
          if( errorMessageBlock ) {
            errorTextBlock.innerHTML = errorMessageBlock.innerText
          }
        }
      });

      this.on('addedfile',
        /**
         * @param {File} file
         */
        function(file) {
          file.previewElement.querySelector('.dz-file-extension').innerHTML = getExtension(file.name)
        }
      )
      this.on('complete',
        /**
         * @param {File} file
         */
        function (file) {
          file.xhr && afterUploadToServer(this, file, orderAttachmentsIdsElement)(file.xhr)
        },
      )
      this.on('removedfile',
        /**
         * @param {File} file
         */
        function (file) {
          removeFromServer(afterRemoveFromServer(this, file, orderAttachmentsIdsElement), orderAttachmentsIdsElement.dataset.removeUrl)(file.serverFileId)
        },
      )
    },
  })
}
